export default __webpack_public_path__ + "static/media/mp3.3649e04b.svg";